import { SET_SATSER, SatserActionTypes } from './Types';
import { StamdataNordenHelgradModel } from '../../Models/StamdataNordenHelgradModel';

const initialState: StamdataNordenHelgradModel | null = null;

export function satserReducer(state: StamdataNordenHelgradModel | null = initialState, action: SatserActionTypes): StamdataNordenHelgradModel | null {
    switch (action.type) {
        case SET_SATSER: {
            return action.payload;
        }
        default:
            return state;
    }
}
